export default  {
    knobX: 71,
    knobY: 71,
    svg:`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="204px" height="204px" viewBox="0 0 204 204" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="50%" y1="50%" x2="50%" y2="100%" id="f7066879-f57b-f7ab-0a62-b7e76659fc9a">
            <stop stop-color="#444040" stop-opacity="0.51098279" offset="0%"/>
            <stop stop-color="#131111" stop-opacity="0.893200861" offset="100%"/>
        </linearGradient>
        <circle id="969b1f52-759b-c83e-61ec-394ce88ab344" cx="98.0400009" cy="98.0400009" r="98.0400009"/>
        <filter x="-3.3%" y="-3.3%" width="106.6%" height="106.6%" filterUnits="objectBoundingBox" id="4400ad0d-4d36-0bc1-05b0-ba46e610ec97">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="666891d9-1c7d-33e0-6996-abfa6bc7e950">
            <stop stop-color="#FFFFFF" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#000000" stop-opacity="0.5" offset="100%"/>
        </linearGradient>
        <circle id="2ecb830f-8637-8aaf-9333-658361cb9f49" cx="98" cy="98" r="86"/>
        <filter x="-4.1%" y="-3.5%" width="108.1%" height="108.1%" filterUnits="objectBoundingBox" id="38812cc9-6961-10e7-6c57-df005b28946b">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="s13" transform="translate(4.000000, 4.000000)">
            <g id="container">
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#4400ad0d-4d36-0bc1-05b0-ba46e610ec97)" xlink:href="#969b1f52-759b-c83e-61ec-394ce88ab344"/>
                    <use stroke="#979797" stroke-width="1" fill="url(#f7066879-f57b-f7ab-0a62-b7e76659fc9a)" fill-rule="evenodd" xlink:href="#969b1f52-759b-c83e-61ec-394ce88ab344"/>
                </g>
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#38812cc9-6961-10e7-6c57-df005b28946b)" xlink:href="#2ecb830f-8637-8aaf-9333-658361cb9f49"/>
                    <use fill="" fill-rule="evenodd" xlink:href="#2ecb830f-8637-8aaf-9333-658361cb9f49"/>
                    <use stroke="#4A4A4A" stroke-width="1" fill="url(#666891d9-1c7d-33e0-6996-abfa6bc7e950)" fill-rule="evenodd" xlink:href="#2ecb830f-8637-8aaf-9333-658361cb9f49"/>
                </g>
                <g id="knob" transform="translate(27.431373, 27.431373)">
                    <circle id="Oval-5" fill="#322E2E" cx="71" cy="71" r="71"/>
                    <path d="M70.0686275,4.17063061 L86.5686275,65.2689929 C81.3642501,66.811221 75.8642501,67.5735686 70.0686275,67.5560356 C64.2730048,67.5385027 58.7730048,66.7761551 53.5686275,65.2689929 L70.0686275,4.17063061 Z" id="Rectangle-Copy" fill="#E6D7D7" transform="translate(70.068627, 35.863481) scale(1, -1) translate(-70.068627, -35.863481) "/>
                </g>
            </g>
        </g>
    </g>
</svg>
`
}